import { forwardRef, FunctionComponent, SVGProps } from "react";

import { useFeatureSwitch } from "components/FeatureSwitch";

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>;

// Today's SVG, or its 2026 rebrand copy when REACT_APP_USE_REBRAND_2026 is on.
// forwardRef: some SVGs sit inside Headless UI's Transition, which needs the <svg> element.
export function rebrandSvg(Svg: SvgComponent, RebrandSvg: SvgComponent) {
  return forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
    const isRebrand = useFeatureSwitch("REACT_APP_USE_REBRAND_2026");
    const Chosen = isRebrand ? RebrandSvg : Svg;

    return <Chosen { ...props } ref={ ref } />;
  });
}
